import { NetworkRequestOptions, NetworkRequestUIOptions } from '../interfaces/request-options';

export const BACKGROUND_NETWORK_REQ_UI_OPTIONS: NetworkRequestUIOptions = {
  showSuccessMsg: false,
  showErrorMsg: false,
  handleNetworkError: false,
  handlePromiseCancelError: false,
  handleUnauthorisedResponse: true,
  unauthorisedHandleNext: true
};

export const DEFAULT_NETWORK_REQ_OPTIONS: NetworkRequestOptions = {
  networkOptions: {},
  uiOptions: BACKGROUND_NETWORK_REQ_UI_OPTIONS,
  requireAuth: true
};

export const NETWORK_REQ_UI_OPTIONS_WITH_TOAST: NetworkRequestUIOptions = {
  ...BACKGROUND_NETWORK_REQ_UI_OPTIONS,
  showErrorMsg: true,
  showSuccessMsg: true
};

export const NETWORK_REQ_OPTIONS_WITH_TOAST: NetworkRequestOptions = {
  ...DEFAULT_NETWORK_REQ_OPTIONS,
  uiOptions: NETWORK_REQ_UI_OPTIONS_WITH_TOAST
};
